/*
 * @Author: Yun
 * @Date: 2023-11-29 12:17:35
 * @Last Modified by: Yun
 * @Last Modified time: 2023-11-30 10:10:38
 */
import React, { useEffect } from 'react'
import { ConfigProvider } from 'cgtd'
import PrimaryLayout from './layout'
import en from 'cgtd/lib/locale/en_US'
import './App.css'

function App() {
    useEffect(() => {}, [])
    return (
        <ConfigProvider locale={en}>
            <PrimaryLayout />
        </ConfigProvider>
    )
}

export default App
